import React from 'react'
import { Breadcrumbs } from '../../../AbstractElements'
import RoleTable from './RoleTable'

export default function AdminRole() {
  return (
    <div>
       <Breadcrumbs mainTitle="Roles" parent="General" title="Roles" />
       <RoleTable />
    </div>
  )
}

